"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHAudioScene = exports.KHGenericAudioScene = exports.SFXManager = void 0;
class SFXManager {
    constructor(scene, info) {
        this.info = info;
        this.clips = [];
        const assets = Array.isArray(info.asset) ? info.asset : [info.asset];
        for (const asset of assets) {
            this.clips.push(scene.sound.add(info.key, { volume: asset.volume || 1 }));
        }
    }
    play() {
        if (this.clips.length === 0)
            return;
        if (this.clips.length === 1) {
            this.clips[0].play();
        }
        else {
            this.clips[Math.floor(Math.random() * this.clips.length)].play();
        }
    }
}
exports.SFXManager = SFXManager;
class KHGenericAudioScene extends Phaser.Scene {
    constructor(name) {
        super(name || "KHGenericAudioScene");
        this.musicVolume = 1;
        this.sfxVolume = 1;
        this.trackVolume = 1;
    }
    create() {
        this.sfxMap = new Map();
        const sfxClips = this.getSfxInfo();
        for (let clip of sfxClips) {
            const man = new SFXManager(this, clip);
            this.sfxMap.set(man.info.key, man);
        }
    }
    /**
     * Sets the volume multiplier for all tracks. This will
     * be multiplied by the track volume to get the overall
     * volume. Settings this to zero is effectively a mute
     * on every track played by this.
     * @param volume Volume multiplier for all music played
     * by this scene.
     */
    setMusicVolume(volume) {
        this.musicVolume = volume;
        this.recomputeVolume();
    }
    /**
     * Sets the volume of the individual track. This will
     * not affect the volume of any subsequent tracks.
     * @param volume Volume for the current audio track.
     */
    setTrackVolume(volume) {
        this.trackVolume = volume;
        this.recomputeVolume();
    }
    recomputeVolume() {
        this.audio.volume = this.getVolume();
    }
    getVolume() {
        return this.trackVolume * this.musicVolume;
    }
    playSfx(clip) {
        const sfx = this.sfxMap.get(clip);
        if (!sfx) {
            console.warn('Trying to play non-existent clip', clip);
        }
        else {
            sfx.play();
        }
    }
    play(audio, loop, fade_in, trackVolume = 1, force_restart = false) {
        if (audio == this.current_clip && !force_restart)
            return;
        this.stop();
        if (this.fadeTween) {
            this.fadeTween.stop();
            this.fadeTween = null;
        }
        this.audio = this.sound.add(audio, { loop: loop });
        this.audio.play();
        console.log("Now Playing - " + audio);
        this.trackVolume = trackVolume;
        if (fade_in) {
            this.fadeAudio(false, 1000);
        }
        else {
            this.recomputeVolume();
        }
        this.current_clip = audio;
    }
    fadeOut(duration) {
        this.fadeAudio(true, duration, () => {
            this.stop();
        });
    }
    fadeAudio(fadingOut, duration, callback) {
        if (this.fadeTween)
            this.fadeTween.stop();
        this.audio.volume = fadingOut ? this.getVolume() : 0;
        this.fadeTween = this.tweens.addCounter({
            from: 0,
            to: 100,
            duration,
            onUpdate: tween => {
                const from = fadingOut ? this.getVolume() : 0;
                const to = fadingOut ? 0 : this.getVolume();
                this.audio.volume = Phaser.Math.Linear(from, to, to / 100);
            },
            onStop: () => {
                this.recomputeVolume();
            },
            onComplete: () => {
                this.fadeTween = null;
                this.recomputeVolume();
                callback === null || callback === void 0 ? void 0 : callback();
            }
        });
    }
    stop() {
        if (!this.audio)
            return;
        this.audio.stop();
        this.audio = null;
        this.current_clip = null;
    }
    static registerClips(scene, clips) {
        for (const info of clips) {
            const assets = Array.isArray(info.asset) ? info.asset : [info.asset];
            for (const asset of assets) {
                scene.load.audio(asset.loadKey, asset.url);
            }
        }
    }
    getSfxInfo() {
        return [];
    }
}
exports.KHGenericAudioScene = KHGenericAudioScene;
class KHAudioScene extends KHGenericAudioScene {
    constructor() {
        super(KHAudioScene.NAME);
    }
}
KHAudioScene.NAME = "KHAudioScene";
exports.KHAudioScene = KHAudioScene;
